import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FormSection } from 'Components/ComponentLibrary/Molecules/FormSection';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';
import fr from 'facet-rest';
import { ProfileImageUploader } from 'Components/ComponentLibrary/Organisms/ProfileImageUploader';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';

// DependentDetailForm could be used on a Card or in a dialog
export const DependentDetailForm = ({ onProfileImageUpload }) => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack direction={'column'} spacing={2}>
      <FormSection title={'Basic Information'}>
        <FDInputRow>
          <MetaControlField attr={'firstName'} flex={1} />
          <MetaControlField attr={'lastName'} flex={1} />
          <MetaControlField attr={'preferredName'} flex={1} />
          <MetaControlField attr={'birthDate'} flex={1} />
        </FDInputRow>
        {resource.withRelationship(fr.relationships.profileImage.name, (rel) => {
          return (
            <FDStack justifyContent={'flex-start'}>
              <ProfileImageUploader
                profileImageRelationship={rel}
                onSuccess={onProfileImageUpload}
              />
            </FDStack>
          );
        }, () => null)}
      </FormSection>
      <FormSection title={'Other Information'}>
        <FDInputRow>
          <MetaControlField attr={'relationship'} flex={1} />
          <MetaControlField attr={'emailAddresses'} flex={1} />
        </FDInputRow>
      </FormSection>
    </FDStack>
  );
};

DependentDetailForm.defaultProps = {
  onProfileImageUpload: undefined,
};

DependentDetailForm.propTypes = {
  onProfileImageUpload: PropTypes.func,
};
